import React, { Component, Fragment } from 'react';
import { Button } from 'semantic-ui-react';
import ReactModal from 'react-modal';

class ConfirmationModal extends Component {
  state = { open: false };

  handleOpen = (e) => {
    const { disabled = false } = this.props;
    if (disabled) return;
    if (e && e.stopPropagation) e.stopPropagation();
    this.setState({ open: true });
  }

  handleClose = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    this.setState({ open: false });
  }

  handleClickConfirmBtn = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();

    const { handleConfirm, closeAfterConfirm = true } = this.props;

    handleConfirm(e);

    if (closeAfterConfirm) {
      this.handleClose();
    }
  };

  render() {
    const { open } = this.state;
    const {
      trigger, title, cancelText, confirmText
    } = this.props;

    return (
      <Fragment>
        <div onClick={this.handleOpen} className='comfirmationModal_trigger'>
          {trigger}
        </div>

        <ReactModal
          isOpen={open}
          onRequestClose={this.handleClose}
          className='reactModal comfirmationModal'
          overlayClassName='reactModal_overlay'
          ariaHideApp={false}
          onClick={e => { e.stopPropagation(); }}
        >
          <h1 className='comfirmationModal_title'>{title}</h1>
          <div className='comfirmationModal_footer'>
            <Button
              size='large'
              inverted
              type='button'
              className='button no-btn'
              onClick={this.handleClose}
            >
              {cancelText}
            </Button>
            <Button
              primary
              size='large'
              type='button'
              className='button yes-btn'
              onClick={this.handleClickConfirmBtn}
            >
              {confirmText}
            </Button>
          </div>
        </ReactModal>
      </Fragment>
    );
  }
}

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/common/confirmationModal.js